import type { CSSProperties, ReactNode } from "react";
import { Box, Button, Card, CardContent, FormControl } from "@mui/material";
import { MdFileDownload } from "react-icons/md";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { PiSortAscendingLight, PiSortDescendingLight } from "react-icons/pi";

export const reportHeadCellStyle = (
  extras: CSSProperties = {},
): CSSProperties => ({
  backgroundColor: "#f5f5f5",
  borderRight: "1px solid #e0e0e0",
  fontWeight: 600,
  fontSize: "12px",
  padding: "8px 12px",
  whiteSpace: "nowrap",
  position: "sticky",
  top: 0,
  zIndex: 1,
  ...extras,
});

export const reportBodyCellStyle = (
  extras: CSSProperties = {},
): CSSProperties => ({
  padding: "6px 12px",
  fontSize: "12px",
  borderRight: "1px solid #e0e0e0",
  color: "#333",
  whiteSpace: "nowrap",
  ...extras,
});

export const reportSelectStyle: CSSProperties = {
  height: "36px",
  fontSize: "14px",
  fontFamily: "inherit",
};

export const reportMenuItemStyle: CSSProperties = {
  fontSize: "14px",
  fontFamily: "inherit",
};

export function AttendanceReportCard({
  toolbar,
  children,
}: {
  toolbar: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="container-fluid p-0 pe-2" style={{ marginTop: "12px" }}>
      <Card>
        <CardContent
          style={{
            height: "calc(100vh - 90px)",
            overflow: "hidden",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            mb={1}
            style={{ flexShrink: 0 }}
          >
            {toolbar}
          </Box>
          {children}
        </CardContent>
      </Card>
    </div>
  );
}

export function AttendanceReportSearch({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <FormControl variant="outlined" size="small">
      <input
        type="text"
        placeholder="Search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          padding: "8px 12px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          minWidth: "200px",
          height: "36px",
          fontSize: "14px",
          fontFamily: "inherit",
          outline: "none",
          transition: "border-color 0.2s",
        }}
      />
    </FormControl>
  );
}

export function AttendanceReportExportButton({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      variant="outlined"
      size="small"
      onClick={onClick}
      disabled={disabled}
      startIcon={<MdFileDownload />}
      style={{
        height: "36px",
        fontSize: "12px",
        textTransform: "none",
        border: "1px solid #ccc",
        color: "#666",
        whiteSpace: "nowrap",
      }}
    >
      Export
    </Button>
  );
}

export function ReportSortHeader({
  label,
  active,
  direction,
  onClick,
}: {
  label: string;
  active: boolean;
  direction: "asc" | "desc";
  onClick: () => void;
}) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <span style={{ color: "#666" }}>{label}</span>
      <span style={{ marginLeft: "4px" }}>
        {active ? (
          direction === "asc" ? (
            <PiSortAscendingLight size={16} />
          ) : (
            <PiSortDescendingLight size={16} />
          )
        ) : (
          <HiOutlineDotsVertical size={16} />
        )}
      </span>
    </Box>
  );
}
